const UserActionType = {
  SET_SELECT_ALL_USER_CHECKED: 'SET_SELECT_ALL_USER_CHECKED',
  SET_SELECTED_USER_IDS: 'SET_SELECTED_USER_IDS',
  SET_SELECTED_USERS_NAME: 'SET_SELECTED_USERS_NAME',
  SET_USERS_VALUE: 'SET_USERS_VALUE',
};

export default UserActionType;